var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',_vm._l((Object.keys(_vm.options)),function(option){return _c('li',{key:option},[_c('Toggle',{staticClass:"toggle",attrs:{"value":_vm.options[option].show},on:{"change":function($event){_vm.options[option].show = !_vm.options[option].show}}}),_vm._v(" "+_vm._s(_vm.options[option].display)+" ")],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }